import { hotkeyService } from 'common';

export const setup = () => {
    hotkeyService.setup();
};
